"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptanonCookieInfo = void 0;
const utils_common_get_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-cookie"));
const getOptanonCookieInfo = () => {
    let optanon = (0, utils_common_get_cookie_1.default)("OptanonConsent");
    optanon = decodeURIComponent(optanon);
    let ad_storage = optanon && optanon.indexOf("C0004:1") !== -1 ? "granted" : "denied";
    let analytics_storage = optanon && optanon.indexOf("C0002:1") !== -1 ? "granted" : "denied";
    let ad_personalization = ad_storage;
    let ad_user_data = ad_storage;
    return {
        ad_storage,
        analytics_storage,
        ad_personalization,
        ad_user_data,
    };
};
exports.getOptanonCookieInfo = getOptanonCookieInfo;
exports.default = exports.getOptanonCookieInfo;
//# sourceMappingURL=index.js.map